module.exports = __webpack_public_path__ + "img/brightness-high.e365b90e.svg";